import { render, staticRenderFns } from "./CuPhoneInput.vue?vue&type=template&id=179008f1&scoped=true"
import script from "./CuPhoneInput.vue?vue&type=script&lang=js"
export * from "./CuPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./CuPhoneInput.vue?vue&type=style&index=0&id=179008f1&prod&lang=css"
import style1 from "./CuPhoneInput.vue?vue&type=style&index=1&id=179008f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179008f1",
  null
  
)

export default component.exports